function updateCartIconBubbleCount(bubbleHTML) {
  if (!bubbleHTML) return;
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (!cartIcon) return;

  // Guarantee plain link behavior
  cartIcon.removeAttribute('role');
  cartIcon.removeAttribute('aria-haspopup');
  cartIcon.removeAttribute('data-mobile-cart-drawer');
  if (!cartIcon.getAttribute('aria-label')) {
    cartIcon.setAttribute('aria-label', 'Cart');
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(bubbleHTML, 'text/html');
  const newBubble = doc.querySelector('.cart-count-bubble');
  const existingBubble = cartIcon.querySelector('.cart-count-bubble');

  if (newBubble) {
    if (existingBubble) {
      existingBubble.replaceWith(newBubble);
    } else {
      cartIcon.appendChild(newBubble);
    }
  } else if (existingBubble) {
    existingBubble.remove();
  }
}
window.updateCartIconBubbleCount = updateCartIconBubbleCount;

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    // The cart icon must ALWAYS navigate directly to the cart page (/cart).
    // Ensure it remains a plain link and never opens the cart drawer.
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.removeAttribute('role');
    cartLink.removeAttribute('aria-haspopup');
    cartLink.removeAttribute('data-mobile-cart-drawer');
    cartLink.classList.add('flo-ignore-optimisation');
    if (!cartLink.getAttribute('aria-label')) {
      cartLink.setAttribute('aria-label', 'Cart');
    }
    cartLink.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      window.location.href = window.routes?.cart_url || '/cart';
    };
  }

  open(triggeredBy) {
    // handleFloCartBtn();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.documentElement.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);

    document.documentElement.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      const detailsElement = event.currentTarget.closest('details');
      if (!detailsElement) return;
      event.currentTarget.setAttribute('aria-expanded', !detailsElement.hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      if (section.id === 'cart-icon-bubble') {
        const bubbleHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        updateCartIconBubbleCount(bubbleHTML);
        return;
      }
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // Re-init Swiper and cart count after new HTML is injected via renderContents.
      // This avoids the second network fetch that onCartUpdate() was making just
      // to reach these two DOM-only calls.
      if (typeof initDrawerSwiper === 'function') initDrawerSwiper();
      if (typeof updateCartCount_cs === 'function') updateCartCount_cs();
      if (typeof initCartRecs === 'function') initCartRecs();
      if (typeof window.initGiftWrapper === 'function') window.initGiftWrapper();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

async function initCartRecs() {
  const el = document.querySelector('[data-cart-recs]');
  if (!el || !el.dataset.productId) { el?.setAttribute('hidden', ''); return; }

  const productId = el.dataset.productId;
  const cartIds = new Set((el.dataset.cartIds || '').split(',').map(Number).filter(Boolean));

  try {
    // Cross-sell source order:
    //  1. Hand-picked list from the first cart product's metafield custom.fbt_products
    //     (same list that powers the PDP "Frequently Bought Together").
    //  2. Shopify "complementary" (Search & Discovery), then algorithmic "related" — so
    //     the strip is never empty even for products without a curated list.
    const fetchRecs = async (intent) => {
      const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=10&intent=${intent}`);
      const data = await res.json();
      return (data.products || []).filter(p => !cartIds.has(p.id));
    };
    const fetchByHandles = async (handles) => {
      const results = await Promise.all(handles.map(h =>
        fetch(`/products/${h}.js`).then(r => (r.ok ? r.json() : null)).catch(() => null)
      ));
      return results.filter(Boolean).filter(p => !cartIds.has(p.id));
    };
    const crossHandles = (el.dataset.crossSell || '').split(',').map(s => s.trim()).filter(Boolean);
    let recs = crossHandles.length ? await fetchByHandles(crossHandles) : [];
    if (!recs.length) recs = await fetchRecs('complementary');
    if (!recs.length) recs = await fetchRecs('related');
    recs = recs.slice(0, 4);

    if (!recs.length) { el.setAttribute('hidden', ''); return; }

    el.removeAttribute('hidden');
    el.innerHTML = `
      <div class="cart-recs__header">
        <p class="cart-recs__title">Complete your look</p>
        <div class="cart-recs__nav">
          <button class="cart-recs__prev" type="button" aria-label="Previous">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          </button>
          <button class="cart-recs__next" type="button" aria-label="Next">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
          </button>
        </div>
      </div>
      <div class="cart-recs__swiper swiper">
        <div class="swiper-wrapper">
          ${recs.map(p => {
            const v = p.variants[0];
            const img = p.featured_image ? p.featured_image.replace(/\.(jpg|png|webp)(\?|$)/, '_300x.$1$2') : '';
            const fmt = (cents) => window.Shopify?.formatMoney ? window.Shopify.formatMoney(cents) : '₹' + (cents / 100).toFixed(2);
            const hasVariants = p.variants.length > 1;
            const variantSelect = hasVariants ? `
              <select class="cart-rec-card__variant-select" aria-label="Select variant">
                ${p.variants.map(pv => `<option value="${pv.id}" data-price="${fmt(pv.price)}" ${!pv.available ? 'disabled' : ''}>${pv.title}${!pv.available ? ' · Sold out' : ''}</option>`).join('')}
              </select>` : '';
            return `
              <div class="swiper-slide">
                <div class="cart-rec-card">
                  <div class="cart-rec-card__img-wrap">
                    <a href="${p.url}" class="cart-rec-card__img-link">
                      <img src="${img}" alt="${p.title}" width="200" height="240" loading="lazy">
                    </a>
                    ${variantSelect}
                  </div>
                  <p class="cart-rec-card__title">${p.title}</p>
                  <p class="cart-rec-card__price" data-rec-price>${fmt(v.price)}</p>
                  <button class="cart-rec-card__atc" type="button" data-rec-vid="${v.id}">Add</button>
                </div>
              </div>`;
          }).join('')}
        </div>
      </div>`;

    if (typeof Swiper !== 'undefined') {
      new Swiper(el.querySelector('.cart-recs__swiper'), {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: {
          prevEl: el.querySelector('.cart-recs__prev'),
          nextEl: el.querySelector('.cart-recs__next'),
        },
      });
    }

    el.querySelectorAll('.cart-rec-card__variant-select').forEach(sel => {
      sel.addEventListener('change', (e) => {
        e.stopPropagation();
        const card = sel.closest('.cart-rec-card');
        const btn = card.querySelector('[data-rec-vid]');
        const priceEl = card.querySelector('[data-rec-price]');
        const opt = sel.options[sel.selectedIndex];
        btn.dataset.recVid = sel.value;
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      });
    });

    el.querySelectorAll('[data-rec-vid]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const vid = Number(btn.dataset.recVid);
        btn.disabled = true;
        btn.innerHTML = '<span class="cart-rec-spinner"></span>';
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: vid, quantity: 1 }),
          });
          btn.textContent = 'Added!';
          setTimeout(() => { btn.disabled = false; btn.textContent = 'Add'; }, 2000);

          const cartDrawerItems = document.querySelector('cart-drawer-items');
          if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
            cartDrawerItems.onCartUpdate();
          }
        } catch (_) {
          btn.disabled = false;
          btn.textContent = 'Add';
        }
      });
    });
  } catch (_) {
    el?.setAttribute('hidden', '');
  }
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
